import React from 'react'
import { useHistory } from 'react-router-dom'
import { Tooltip } from 'antd'
import './index.styl'
import { CustomButton } from '../../../../components'
import MSImage from 'images/MSDefaultImage.png'
import { useSelector } from 'react-redux'

const SessionAndPassesCard = ({ subscriptions = [], sessions = [], passes = [], items = [], id, userId }) => {
  const history = useHistory()
  const { user } = useSelector(state => state.session)
  const handleGetMembership = () => {
    if (!user) {
      history.push(`/auth/sign-in?redirectTo=/buyPage/${id}/${userId}`)
    } else {
      history.push(`/buyPage/${id}/${userId}`)
      window.scrollTo(0, 0)
    }
    window.scrollTo(0, 0)
  }

  return (
    <>
      {subscriptions?.length > 0 && (
        <div className='buyPassesWrapper'>
          <div className='title'>Subscription Passes</div>
          <div className='passesCardWrapper'>
            {subscriptions?.map((item, key) => (
              <div className='cardWrapper' key={key}>
                {item.name?.length >= 15 ? (
                  <Tooltip placement='top' title={item.name}>
                    <div className='category'>{item.name}</div>
                  </Tooltip>
                ) : (
                  <div className='category'>{item.name}</div>
                )}
                <div className='price'>{'$' + item.price}</div>
                <div className='duration'>{item.duration + ' recurring charge'}</div>
                {item.description?.length >= 30 ? (
                  <Tooltip placement='top' title={item.description}>
                    <div className='description'>
                      {`${item.description.substring(0, 29)}...`}
                    </div>
                  </Tooltip>
                ) : (
                  <div className='description'>{item.description}</div>
                )}
                <CustomButton
                  text='Get Now'
                  className='buyNow'
                  type='dark'
                  onClick={handleGetMembership}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {passes?.length > 0 && (
        <div className='buyPassesWrapper'>
          <div className='title'>Passes</div>
          <div className='passesCardWrapper'>
            {passes?.map((item, key) => (
              <div className='cardWrapper' key={key}>
                {item.name?.length >= 15 ? (
                  <Tooltip placement='top' title={item.name}>
                    <div className='category'>{item.name}</div>
                  </Tooltip>
                ) : (
                  <div className='category'>{item.name}</div>
                )}
                <div className='price'>{'$' + item.price}</div>
                <div className='duration'>{item.duration === 'Monthly' ? 'Good until end of Month' : `Good until end of Year ${item.year}`}</div>
                {item.description?.length >= 30 ? (
                  <Tooltip placement='top' title={item.description}>
                    <div className='description'>
                      {`${item.description.substring(0, 29)}...`}
                    </div>
                  </Tooltip>
                ) : (
                  <div className='description'>{item.description}</div>
                )}
                <CustomButton
                  text='Get Now'
                  className='buyNow'
                  type='dark'
                  onClick={handleGetMembership}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {sessions?.length > 0 && (
        <div className='buySessionWrapper'>
          <div className='title'>Sessions</div>
          <div className='sessionCardWrapper'>
            {sessions?.map((item, key) => (
              <div className='cardWrapper' key={key}>
                {item.name?.length >= 15 ? (
                  <Tooltip placement='top' title={item.name}>
                    <div className='category'>{item.name}</div>
                  </Tooltip>
                ) : (
                  <div className='category'>{item.name}</div>
                )}
                <div className='price'>{'$' + item.price}</div>
                <div className='session'>{item.sessionSize} Sessions</div>
                {item.description?.length >= 30 ? (
                  <Tooltip placement='top' title={item.description}>
                    <div className='description'>
                      {`${item.description.substring(0, 29)}...`}
                    </div>
                  </Tooltip>
                ) : (
                  <div className='description'>{item.description}</div>
                )}
                <CustomButton
                  text='Get Now'
                  className='buyNow'
                  type='dark'
                  onClick={handleGetMembership}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {items?.length > 0 && (
        <div className='itemsWrapper'>
          <div className='title'>Shop</div>
          <div className='itemsCardWrapper'>
            {items.map((item, key) => (
              <div key={key} className='cardWrapper'>
                <img src={item?.imageUrl?.thumbnail1 || MSImage} alt=' ' />
                {item.name?.length >= 25 || item.categoryName?.length >= 25 ? (
                  <Tooltip placement='top' title={item.name || item.categoryName}>
                    <div className='category'>{item.name || item.categoryName}</div>
                  </Tooltip>
                ) : (
                  <div className='category'>{item.name || item.categoryName}</div>
                )}
                <div className='price'>{'$' + item.price}</div>
                <CustomButton
                  text='Get Now'
                  className='buyNow'
                  type='dark'
                  onClick={handleGetMembership}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default SessionAndPassesCard
